import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "intro" }
const _hoisted_4 = { class: "link" }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = { class: "privacy-card-head" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-desc" }
const _hoisted_9 = { class: "item-row" }
const _hoisted_10 = { class: "disclaimer" }
const _hoisted_11 = { class: "link" }

import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { privacyCardKey, privacyItemKey } from '../i18n-keys';
import CardIcon from './CardIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppPrivacy',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_van_row, { class: "section-head" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "22" }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('appStore.privacyTitle')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "16",
              color: "#9ca3af"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(t)('appStore.privacyIntroPrefix')) + " ", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('appStore.developerName')), 1),
      _createTextVNode(" " + _toDisplayString(_unref(t)('appStore.privacyIntroMiddle')) + " ", 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('appStore.privacyPolicyLink')), 1),
      _createTextVNode(" " + _toDisplayString(_unref(t)('appStore.privacyIntroSuffix')), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).privacy.cards, (card) => {
      return (_openBlock(), _createElementBlock("div", {
        key: card.id,
        class: "privacy-card"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CardIcon, {
            kind: card.icon
          }, null, 8, ["kind"]),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)(_unref(privacyCardKey)(card.i18nKey, 'Title'))), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)(_unref(privacyCardKey)(card.i18nKey, 'Description'))), 1)
        ]),
        _createVNode(_component_van_row, { class: "items-grid" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(card.items, (item) => {
              return (_openBlock(), _createBlock(_component_van_col, {
                key: item.i18nKey,
                span: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_van_icon, {
                      name: item.icon,
                      size: "16",
                      color: "#374151"
                    }, null, 8, ["name"]),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)(_unref(privacyItemKey)(item.i18nKey))), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _createElementVNode("p", _hoisted_10, [
      _createTextVNode(_toDisplayString(_unref(t)('appStore.privacyDisclaimer')) + " ", 1),
      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('appStore.learnMore')), 1)
    ])
  ]))
}
}

})